import React from 'react';
import { Redirect, withRouter, RouteComponentProps } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { fetchLawyersByOffice } from '../../lawFirm.api';
import { LawyersInOffice } from '../LawyersInOffice';
import { LawFirmInfos, Office as OfficeType } from '../../lawFirm.types';
import { Lawyer } from '../../../entity/entity.types';
import { OfficeHeader } from './OfficeHeader';
import { PageCenter } from '../../../components/page/Page';
import { LoaderWithText } from '../../../components/loader/LoaderWithText';
import {
  EntityCardContainer,
  EntityCardItem,
} from '../../../entity/components/EntityCardComponents';

type Props = RouteComponentProps & {
  lawFirmInfos: LawFirmInfos;
  match: {
    params: {
      nic: string;
    };
  };
  accessPremium: boolean;
};

type State = {
  office: OfficeType;
  lawyers: Array<Lawyer>;
  newLocation: string;
  loaded: boolean;
};

export class RawOffice extends React.Component<Props, State> {
  state: State = {
    office: {
      nic: '',
      route: '',
      ville: '',
      nbLawyers: '',
      lawOfficeId: '',
      adresse: '',
      dateCreation: '',
      dateRadiation: '',
    },
    lawyers: [],
    newLocation: '',
    loaded: false,
  };

  async componentDidMount() {
    window.dispatchEvent(new CustomEvent('showNav', { detail: false }));
    const office = this.props.lawFirmInfos.offices.find(
      o => o.nic === this.props.match.params.nic,
    );

    if (!office) {
      const url = this.props.location.pathname;
      const parts = url.split('/');
      // On récupère l'url du siège
      const newUrl = parts.slice(0, parts.length - 2).join('/');
      this.setState({ newLocation: newUrl });
    } else {
      const { lawyers } = (
        await fetchLawyersByOffice(office.lawOfficeId, office.nic)
      ).data;
      this.setState({ office, lawyers, loaded: true });
    }
  }

  render() {
    const {
      lawFirmInfos: { name, mainRoute },
      accessPremium,
    } = this.props;
    const { newLocation, loaded, office, lawyers } = this.state;
    if (newLocation) {
      return <Redirect to={newLocation} />;
    }
    if (!loaded) {
      return (
        <PageCenter>
          <EntityCardContainer>
            <EntityCardItem>
              <LoaderWithText>
                <FormattedMessage id="law-firm/page/office/Office.tsx/1" />
              </LoaderWithText>
            </EntityCardItem>
          </EntityCardContainer>
        </PageCenter>
      );
    }
    const source = 'office';
    return (
      <PageCenter>
        <OfficeHeader firmName={name} firmLink={mainRoute} office={office} />
        {lawyers.length > 0 && (
          <LawyersInOffice
            isBranchOffice
            lawyers={lawyers}
            source={source}
            accessPremium={accessPremium}
          />
        )}
      </PageCenter>
    );
  }
}

export const Office = withRouter(RawOffice);
